var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"status",class:[("status__" + (_vm.status.color))]},[_vm._v(" "+_vm._s(_vm.status.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }